"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionForm = void 0;
const number_1 = require("@utils/object/number");
const core_1 = require("@web3-react/core");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const React = __importStar(require("react"));
const token_hooks_1 = require("@hooks/token.hooks");
const tokens_reducer_1 = require("@app/store/reducers/tokens.reducer");
const event_timer_1 = require("../event-timer");
const token_info_1 = require("../token-info");
const auction_bid_form_1 = require("../auction-bid-form");
const auction_instant_form_1 = require("../auction-instant-form");
const translation_hooks_1 = require("@hooks/translation.hooks");
require("./styles.scss");
const AuctionForm = (props) => {
    const { auction, updateToken } = props;
    const { account } = (0, core_1.useWeb3React)();
    const translator = (0, translation_hooks_1.usePagesTranslation)("tokenPage.auctionForm");
    const paymentToken = (0, tokens_reducer_1.useTokenByAddress)(auction.paymentTokenAddress);
    const { loaderState, isFirstLoadCompleted } = (0, token_hooks_1.useTokenListByFilter)({ author: auction.token.author.wallet, owner: account || undefined }, { size: 0 });
    const allowedToBid = (isFirstLoadCompleted && Number(loaderState.total || 0) >= auction.minAuthorTokenCount) ||
        auction.minAuthorTokenCount === 0;
    const lastBid = auction.bids.sort((left, right) => new bignumber_js_1.default(right.amount).minus(left.amount).toNumber())[0];
    const auctionInfo = [
        {
            label: lastBid ? translator("currentBid") : translator("minBid"),
            currencySymbol: paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.symbol,
            value: lastBid
                ? (0, number_1.formatAndNormalizeToken)(paymentToken, lastBid === null || lastBid === void 0 ? void 0 : lastBid.amount, paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.decimals)
                : (0, number_1.formatAndNormalizeToken)(paymentToken, auction.minPrice, paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.decimals),
        },
    ];
    const isAuctionExpired = auction.endAuctionDate < new Date().getTime();
    return (React.createElement("div", { className: "c-token-page-auction-form" },
        React.createElement(event_timer_1.EventTimer, { startTime: auction.startAuctionDate, endTime: auction.endAuctionDate, onUpdate: updateToken, eventName: translator("eventName") }),
        React.createElement(token_info_1.TokenInfo, { cells: auctionInfo }),
        !isAuctionExpired && (React.createElement(React.Fragment, null,
            React.createElement(auction_bid_form_1.AuctionBidForm, { auction: auction, allowToBid: allowedToBid, updateToken: updateToken }),
            React.createElement(auction_instant_form_1.AuctionInstantForm, { auction: auction, allowToBuy: allowedToBid, updateToken: updateToken }))),
        isAuctionExpired && React.createElement("b", { className: "c-token-page-auction-form__warning" }, translator("auctionExpiredText"))));
};
exports.AuctionForm = AuctionForm;
